require('@splidejs/splide');
require('@splidejs/splide-extension-video');
import { Splide } from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';

window.splideInstances = [];

window.loadSplide = function(container = '.splide', config) {
    var splide = new Splide(container, config);
    var Components = splide.Components;
    splide.on( 'resized', function() {
        var isOverflow = Components.Layout.isOverflow();
        var list       = Components.Elements.list;
        var lastSlide  = Components.Slides.getAt( splide.length - 1 );
        if ( lastSlide ) {
            // Toggles `justify-content: center`
            list.style.justifyContent = isOverflow ? '' : 'center';
            // Remove the last margin
            if ( ! isOverflow ) {
                lastSlide.slide.style.marginRight = '';
            }
        }
    });
    splide.on( 'mounted', function() {
        const containerElem = document.querySelector(container);
        const videoSlides = containerElem.querySelectorAll('.splide__video__wrapper');
        for (const videoSlide of videoSlides) {
            videoSlide.classList.add('backdrop-blur-md', 'bg-transparent');
        }
    });
    if (config.autoplay) {
        splide.on( 'video:play', function() {
            var autoplay = Components.Autoplay;
            autoplay.pause();
        });
        splide.on( 'video:ended', function() {
            var autoplay = Components.Autoplay;
            autoplay.play();
            Components.Controller.go('>');
        });
    }
    splide.mount({Video});
    window.splideInstances[container] = splide;
    // console.log('loadSplide', container);
};

window.loadSplideEdit = function(container = '.splide', compId = 0) {
    // console.log('loadSplideEdit', container, compId);
    var splide = window.splideInstances[container];
    const containerElem = document.querySelector(container);
    const slides = containerElem.querySelectorAll('.splide__slide');
    var slideId = null;
    var slideIdx = 0;
    slides.forEach(function(elem, key){
        if (elem.getAttribute('data-comp-id') == compId) {
            slideId = elem.id;
            slideIdx = key;
        }
    });
    const { Autoplay, Move } = splide.Components;
    // Disable autoplay
    Autoplay.pause();
    // Goto specific slide matching the editing comp
    Move.jump(slideIdx);
};

window.loadSplideSimple = function(container = '.splide', config) {
    var splide = new Splide(container, config);
    splide.mount();
    window.splideInstances[container] = splide;
};

window.loadSplideSynced = function(containerOne = '.splide', configOne, containerTwo = '.splide', configTwo) {
    var splideOne = new Splide(containerOne, configOne);
    var splideTwo = new Splide(containerTwo, configTwo);
    splideOne.sync(splideTwo);
    splideOne.mount();
    splideTwo.mount();
    window.splideInstances[containerOne] = splideOne;
    window.splideInstances[containerTwo] = splideTwo;
};